// extracted by mini-css-extract-plugin
module.exports = {"inner":"CompareYourFaceLayout_inner__2Di9V","scoreCard":"CompareYourFaceLayout_scoreCard__34gfs","scoreCardShow":"CompareYourFaceLayout_scoreCardShow__3rsv0"};